import React, { useContext } from "react";
import { Modal, Flex, Button, StatusIcon } from "@cisco/spaces-dash-lib-styleguide";
import { I18nContext } from "../../contexts/i18nContext";

function DeleteMetadataPopup(props) {
  const i18n = useContext(I18nContext);
  const { showDeletePopup, cancelDelete, deleteLocation } = props;

  return (
    <Modal size="sm" isOpen={showDeletePopup} className="locDeletePopup">
      <Flex direction="vertical" gap={32} align="center">
        <StatusIcon status="warning" height={48} width={48} />
        <Flex justify="center">
          <div style={{ textAlign: "center" }}>{i18n.t("location-metadata-bulk.sure-want-to-delete-metadata")}?</div>
        </Flex>
        <Flex justify="flex-end" style={{ width: "100%" }}>
          <Button.Group className="modal-footer">
            <Button kind="tertiary" onClick={cancelDelete}>
              {i18n.t("business-location-details.cancel-text")}
            </Button>
            <Button destructive onClick={deleteLocation}>
              {i18n.t("business-location-details.delete-text")}
            </Button>
          </Button.Group>
        </Flex>
      </Flex>
    </Modal>
  );
}

export default DeleteMetadataPopup;
